<template>
  <div class="topic-select">
    <div class="topic-box">
      <span v-if="!value.length" class="placeholder">未添加话题</span>
      <span v-for="(topic, index) in value" :key="index" class="topic-chip">
        <span class="topic-name">{{ topic.topicName }}</span>
        <button type="button" class="topic-remove" @click="removeTopic(index)">×</button>
      </span>
    </div>
    <el-popover
      ref="popover"
      placement="bottom-end"
      trigger="click"
      :width="280"
      popper-class="topic-select-popover"
    >
      <ul class="topic-list">
        <li v-if="!options.length" class="empty">暂无话题</li>
        <li
          v-for="topic in options"
          :key="topic.topicId"
          @click="addTopic(topic)"
        >{{ topic.topicName }}</li>
      </ul>
      <button slot="reference" type="button" class="add-topic-btn" :disabled="value.length >= 10">
        添加话题
      </button>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'TopicSelect',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    addTopic(topic) {
      if (this.value.length >= 10) {
        this.$message.error('只可选择10个话题');
        return;
      }
      this.$emit(
        'input',
        this.value.concat([
          {
            topicId: topic.topicId,
            topicName: topic.topicName,
          },
        ])
      );
      this.$emit('add', {
        topicId: topic.topicId,
        topicName: topic.topicName,
      });
      if (this.$refs.popover) this.$refs.popover.doClose();
    },
    removeTopic(index) {
      const next = this.value.slice();
      next.splice(index, 1);
      this.$emit('input', next);
    },
  },
};
</script>

<style lang="less" scoped>
.topic-select {
  display: flex;
  align-items: center;
  width: 100%;
  /deep/ .el-popover__reference-wrapper {
    flex: none;
  }
  .topic-box {
    flex: 1;
    min-width: 0;
    min-height: 40px;
    padding: 6px 8px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
    line-height: 24px;
  }
  .placeholder {
    color: #c0c4cc;
    font-size: 14px;
  }
  .topic-chip {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    margin: 2px 6px 2px 0;
    padding: 0 4px 0 8px;
    border-radius: 4px;
    background: rgba(4, 203, 205, 0.12);
    color: #04cbcd;
    font-size: 12px;
    line-height: 24px;
  }
  .topic-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .topic-remove {
    margin-left: 2px;
    padding: 0 4px;
    border: 0;
    background: transparent;
    color: #04cbcd;
    font-size: 14px;
    line-height: 22px;
    cursor: pointer;
  }
  .add-topic-btn {
    flex: none;
    height: 40px;
    margin-left: 8px;
    padding: 0 16px;
    border: 1px solid #04cbcd;
    border-radius: 4px;
    background: #fff;
    color: #04cbcd;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      background: #04cbcd;
      color: #fff;
    }
    &:disabled {
      border-color: #dcdfe6;
      background: #f5f7fa;
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}
</style>

<style lang="less">
.topic-select-popover {
  z-index: 4000 !important;
  padding: 0;
  .topic-list {
    max-height: 240px;
    margin: 0;
    padding: 4px 0;
    overflow-y: auto;
    list-style: none;
  }
  li {
    padding: 8px 12px;
    color: #303133;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    &:hover {
      background: rgba(4, 203, 205, 0.12);
      color: #04cbcd;
    }
    &.empty {
      color: #c0c4cc;
      cursor: default;
      background: transparent;
    }
  }
}
</style>
